import { Box, Button, Card, CardBody, CardHeader, Heading, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import React, { useCallback, useMemo } from "react"
import { Trans, useTranslation } from "react-i18next";
import * as Flags from "country-flag-icons/react/3x2";
import OperatorIcon from "../../plugin/components/common/icons/OperatorIcon";

const LanguageCard = () => {
    const { i18n, t } = useTranslation();

    const languages = useMemo(() => {
        return Object.keys(i18n.store?.data);
    }, [i18n.store?.data]);

    const language = useMemo(() => i18n.language.slice(0, 2), [i18n.language]);

    const onLanguageChange = useCallback(
        (selectedLanguage) => {
            i18n.changeLanguage(selectedLanguage);
        },
        [i18n],
    );

    return (
        <Card borderWidth={"1px"} borderColor={"#54C0E8"} width={"full"} padding={"8px"} gap={"8px"} boxShadow={"none"}>
            <CardHeader padding={0}>
                <HStack justifyContent={"flex-start"} paddingX={"5px"}>
                    <Icon as={OperatorIcon} color={"#1F9FFF"} />
                    <Heading fontSize={"14px"} color={"#1F9FFF"} fontWeight={400}>
                        <Trans>operator.language.title</Trans>
                    </Heading>
                </HStack>
            </CardHeader>
            <CardBody padding={0}>
                <HStack justifyContent={"center"} gap={"8px"}>
                    {languages.map((currentLanguage) => {
                        const Flag = Flags[currentLanguage.toUpperCase()] || Flags["US"];

                        return (
                            <Button height={"full"} variant={"ghost"} borderRadius={"7px"} onClick={() => onLanguageChange(currentLanguage)}>
                                <VStack gap={0}>
                                    <Box title={currentLanguage} width={"30px"} height={"30px"} filter={currentLanguage !== language && "opacity(50%)"} borderRadius={"full"} overflow={"hidden"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                        <Icon as={Flag} boxSize={"44px"} />
                                    </Box>
                                    <Text color={currentLanguage !== language ? "gray" : "#1F9FFF"} fontWeight={400}>{t(currentLanguage)}</Text>
                                </VStack>
                            </Button>
                        );
                    })}
                </HStack>
            </CardBody>
        </Card>
    )
}

export default React.memo(LanguageCard)